module.exports = __webpack_public_path__ + "img/message_1.fede227d.png";